import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { createRoot } from 'react-dom/client';

import './styles.scss';

/**
 * Portal
 * This component can be used to extract a component from its parent component
 * to place it at root level. In other words, all children props will be appended
 * at the end of the body.
 */

class Portal extends PureComponent {
  componentDidMount() {
    this.popup = document.createElement('div');
    this.popup.id = this.props.id || 'portal-root';
    if (this.props.className) {
      this.popup.classList.add(this.props.className);
    }

    this.root = createRoot(this.popup);
    document.body.appendChild(this.popup);
    this.doRender();
  }

  componentDidUpdate() {
    this.doRender();
  }

  componentWillUnmount() {
    this.root.unmount();
    document.body.removeChild(this.popup);
  }


  doRender() {
    this.root.render(this.props.children);
  }

  render() {
    return null;
  }
}

Portal.propTypes = {
  children: PropTypes.node,
  id: PropTypes.string,
  className: PropTypes.string,
};

export default Portal;
